import React, { useState } from "react";
import { ChevronDown, Ban, Trash2, RotateCcw, MapPin, Pencil } from "lucide-react";
import { TeamLogo } from "./BracketView";

function TeamRow({ p, idx, onStatus, onRemove, onEdit }) {
  const [open, setOpen] = useState(false);
  const rejected = p.status === "rejected";
  return (
    <div className={`card-surface rounded-xl ${rejected ? "opacity-50" : ""}`} data-testid={`team-${p.id}`}>
      <div className="flex items-center gap-3 p-3">
        <span className="w-6 text-sm font-bold font-head text-white/25">{idx + 1}</span>
        <TeamLogo team={p.name} logos={{ [p.name]: p.logo }} size="w-10 h-10" />
        <button className="flex-1 min-w-0 text-left" onClick={() => setOpen(!open)} data-testid={`team-toggle-${p.id}`}>
          <div className="font-semibold text-white truncate">{p.name}</div>
          <div className="text-xs text-white/40 flex items-center gap-2">{p.country && <span className="flex items-center gap-1"><MapPin size={11} /> {p.country}</span>}<span>{(p.members || []).length} players</span>{rejected && <span className="text-red-400">rejected</span>}</div>
        </button>
        {onStatus && (rejected
          ? <button onClick={() => onStatus(p.id, "confirmed")} title="Restore" className="p-1.5 text-green-400 hover:bg-white/5 rounded" data-testid={`team-restore-${p.id}`}><RotateCcw size={15} /></button>
          : <button onClick={() => onStatus(p.id, "rejected")} title="Reject" className="p-1.5 text-amber-400 hover:bg-white/5 rounded" data-testid={`team-reject-${p.id}`}><Ban size={15} /></button>)}
        {onEdit && <button onClick={() => onEdit(p)} title="Edit team & players" className="p-1.5 text-white/50 hover:text-white rounded" data-testid={`team-edit-${p.id}`}><Pencil size={15} /></button>}
        {onRemove && <button onClick={() => onRemove(p.id)} title="Remove" className="p-1.5 text-white/40 hover:text-red-400 rounded" data-testid={`team-remove-${p.id}`}><Trash2 size={15} /></button>}
        <ChevronDown size={16} className={`text-white/40 transition-transform ${open ? "rotate-180" : ""}`} />
      </div>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-white/5">
          {p.description && <p className="text-sm text-white/60 my-2">{p.description}</p>}
          <div className="grid sm:grid-cols-2 gap-2 mt-2">
            {(p.members || []).map((m, i) => (
              <div key={i} className="rounded-lg bg-black/30 px-3 py-2 text-xs">
                <div className="font-semibold text-white">{m.nickname} <span className="text-white/40 font-normal">· {m.role || "Player"}</span></div>
                <div className="text-white/50">{m.full_name}{m.country ? ` · ${m.country}` : ""}</div>
              </div>
            ))}
          </div>
          {p.registered_by && <div className="text-[11px] text-white/30 mt-2">Registered by {p.registered_by}</div>}
        </div>
      )}
    </div>
  );
}

export default function TeamsList({ participants = [], onStatus, onRemove, onEdit, showRejected = false }) {
  const list = participants.filter((p) => showRejected || p.status !== "rejected");
  if (!list.length) return <div className="text-white/40 py-12 text-center" data-testid="teams-empty">No teams registered yet.</div>;
  return <div className="space-y-2" data-testid="teams-list">{list.map((p, i) => <TeamRow key={p.id} p={p} idx={i} onStatus={onStatus} onRemove={onRemove} onEdit={onEdit} />)}</div>;
}
